(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["header"]) return;
  try {
    

  $( document ).ready(function() {
    $(window).scroll(function() {
      if ($(document).scrollTop() > 120) {
          $('.main-menu-desk').addClass("floating-menu");
          $('.back-to-top').addClass("flex");
          $('.back-to-top').removeClass("hidden");
          $('.site-nav__dropdown').css("top","40px");
      }
      else {
        $('.main-menu-desk').removeClass("floating-menu");
        $('.back-to-top').addClass("hidden");
        $('.back-to-top').removeClass("flex");
        $('.site-nav__dropdown').css("top","155px");
      }
  });

  $(".back-to-top").click(function(){
    window.scrollTo({top: 0, behavior: 'smooth'});
  })

  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sellerhq-hero-banner-alt"] && !window.DesignMode) return;
  try {
    


 $('.arrow-main-desktop-alt').click(function(){
      $(".arrow-main-desktop-alt").toggleClass("active-hero-alt");

      if ($(this).hasClass("active-hero-alt")){
            $(".right-banner-alt").animate({
                width: "100%"
            });
            $(".left-banner-alt").animate({
                marginRight: "-41.666667%"
            })
            $(".pattern-overlay-alt").animate({
                width: "35%",
                marginLeft: "100px",
            })
            
        }else {
            $(".right-banner-alt").animate({
                width: "58.333333%"
            });
            $(".left-banner-alt").animate({
                marginRight: "0%"
            })
            $(".pattern-overlay-alt").animate({
                width: "75%",
                margin: "auto"
            })
    }

  });




  $('.arrow-mobile-drop-alt').click(function(){
    $(".arrow-mobile-drop-alt").toggleClass("active-hero-alt-mobile");

    if ($(this).hasClass("active-hero-alt-mobile")){
        $(".mobile-hidden-product-1-alt").css({
            display: "block"
        });
        $(".mobile-hidden-product-2-alt").css({
            display: "block"
        });
    }else {
        $(".mobile-hidden-product-1-alt").css({
            display: "none"
        });
        $(".mobile-hidden-product-2-alt").css({
            display: "none"
        });
    }
  });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sellerhq-hero"] && !window.DesignMode) return;
  try {
    

$(window).resize(function() {
    clearTimeout($.data(this, 'resizeTimer'));
    $.data(this, 'resizeTimer', setTimeout(function() {

        $(".right-banner").attr('style','');
        $(".left-banner").attr('style','');
        $(".pattern-overlay").attr('style','');
        $(".mobile-hidden-product-1").attr('style','');
        $(".mobile-hidden-product-2").attr('style','');

        $(".right-banner-alt").attr('style','');
        $(".left-banner-alt").attr('style','');
        $(".pattern-overlay-alt").attr('style','');
        $(".mobile-hidden-product-1-alt").attr('style','');
        $(".mobile-hidden-product-2-alt").attr('style','');

        $(".active-hero").removeClass("active-hero");
        $(".active-hero-alt").removeClass("active-hero-alt");

        

    }, 200));
});

 $('.arrow-main-desktop').click(function(){
      $(".arrow-main-desktop").toggleClass("active-hero");

      if ($(this).hasClass("active-hero")){
            $(".right-banner").animate({
                width: "100%"
            });
            $(".left-banner").animate({
                marginLeft: "-41.666667%"
            })
            $(".pattern-overlay").animate({
                width: "35%",
                marginLeft: "100px"
            })
            
        }else {
            $(".right-banner").animate({
                width: "58.333333%"
            });
            $(".left-banner").animate({
                marginLeft: "0%"
            })
            $(".pattern-overlay").animate({
                width: "75%",
                margin: "auto"
            })
    }

  });




  $('.arrow-mobile-drop').click(function(){
    $(".arrow-mobile-drop").toggleClass("active-hero-mobile");

    if ($(this).hasClass("active-hero-mobile")){
        $(".mobile-hidden-product-1").css({
            display: "block"
        });
        $(".mobile-hidden-product-2").css({
            display: "block"
        });
    }else {
        $(".mobile-hidden-product-1").css({
            display: "none"
        });
        $(".mobile-hidden-product-2").css({
            display: "none"
        });
    }
  });
  

  } catch(e) { console.error(e); }
})();
      })();
